// node-modules
import { TweenLite } from 'gsap/TweenMax';

// constants
import { FORM_ELEMENTS, FORM_EVENTS, SELECTORS } from '@/scripts/constants';

// other
import InputBlock from './components/InputBlock';
import Captcha from './components/Captcha';

// assets
import './Form.scss';

export default class Form {
  constructor(form, callback) {
    this.form = form;
    this.$form = $(this.form);
    this.callback = callback || this.defaultCallback;
    const { sitekey = null, devStage = false } = form.dataset;

    this.devStage = devStage;
    this.fields = Array.from(this.form.querySelectorAll(FORM_ELEMENTS.input_block))
      .map(field => new InputBlock(field));
    if (sitekey) {
      this.captcha = new Captcha({
        $element: this.$form.find(FORM_ELEMENTS.captcha_block),
        sitekey,
        $form: this.$form,
      });
    }

    this.$content = this.$form.find(FORM_ELEMENTS.content_block);
    this.$message = this.$form.find(FORM_ELEMENTS.message_block);

    this.activeClass = SELECTORS.active;
    this.loadingClass = SELECTORS.loading;
    this.disabledClass = SELECTORS.disabled;
    this.invalidClass = SELECTORS.invalid;

    this.inProgress = false;

    this.init();
  }

  get data() {
    return this.$form.serialize();
  }

  get isValid() {
    return this.fields.reduce((prev, curr) => prev && curr && curr.valid, true);
  }

  defaultCallback() {
    this.sendData();
  }

  submit(callback) {
    callback(this.data);
  }

  validate() {
    this.fields.forEach((field) => {
      field.validate();
    });
    if (this.isValid) {
      if (this.captcha) {
        this.captcha.execute();
      } else {
        this.$form.trigger(FORM_EVENTS.validation_success);
      }
    } else {
      this.$form.trigger(FORM_EVENTS.validation_fail);
      const target = this.form.querySelector(`.${this.invalidClass}`);
      const distance = $(target).offset().top;
      TweenLite.to(window, 0.8, { scrollTo: { y: distance - 200, autoKill: false } });
    }
  }

  resetForm() {
    this.fields.forEach(field => field.reset());
    if (this.captcha) {
      this.captcha.reset();
    }
  }

  sendData() {
    console.log('form data: ', this.$form.serializeArray()); // eslint-disable-line no-console
    if (!this.devStage) {
      $.post(this.$form.attr('action'), this.data, 'json')
        .done((data) => {
          this.$form.trigger(FORM_EVENTS.submit_success);
          console.log('Form was sent. Success!', { data }); // eslint-disable-line no-console
        })
        .fail((jqXhr, status, error) => {
          this.$form.trigger(FORM_EVENTS.submit_fail);
          console.log("Form wasn't sent", status, error); // eslint-disable-line no-console
        });
    } else {
      setTimeout(() => {
        if (Math.random() > 0.5) {
          this.$form.trigger(FORM_EVENTS.submit_success);
        } else {
          this.$form.trigger(FORM_EVENTS.submit_fail);
        }
      }, 1000);
    }
  }

  init() {
    const $messageLoader = this.$message.find(FORM_ELEMENTS.message_loader);
    const $messageSuccessMark = this.$message.find(FORM_ELEMENTS.message_success__mark);
    const $messageErrorMark = this.$message.find(FORM_ELEMENTS.message_error__mark);

    this.$form.on('submit', (e) => {
      e.preventDefault();
      if (this.inProgress) {
        return;
      }
      this.$form.trigger(FORM_EVENTS.validation_start);
      this.validate();
    });

    this.$form.on(FORM_EVENTS.validation_start, () => {
      this.inProgress = true;
      this.$form.addClass(this.loadingClass);
    });

    this.$form.on(FORM_EVENTS.validation_success, () => {
      this.submit(this.callback.bind(this));
      this.$form.removeClass(this.loadingClass);
      this.$form.trigger(FORM_EVENTS.submit_start);
    });

    this.$form.on(FORM_EVENTS.validation_fail, () => {
      this.inProgress = false;
      this.$form.removeClass(this.loadingClass);
    });

    this.$form.on(FORM_EVENTS.submit_start, () => {
      TweenLite.to(window, 0.8, { scrollTo: { y: this.$content.offset().top - 200, autoKill: false } });
      this.$message.addClass(this.activeClass);
      this.$content.addClass(this.disabledClass);
      $messageLoader.addClass(this.activeClass);
      this.resetForm();
    });

    this.$form.on(FORM_EVENTS.submit_success, () => {
      $messageSuccessMark.addClass(this.activeClass);
      $messageSuccessMark.one('animationend transitionend', () => {
        this.$message.removeClass(this.activeClass);
        this.$content.removeClass(this.disabledClass);
        this.$content.one('transitionend', () => {
          this.inProgress = false;
          $messageLoader.removeClass(this.activeClass);
          $messageSuccessMark.removeClass(this.activeClass);
        });
      });
    });

    this.$form.on(FORM_EVENTS.submit_fail, () => {
      $messageErrorMark.addClass(this.activeClass);

      $messageErrorMark.one('animationend transitionend', () => {
        this.$message.removeClass(this.activeClass);
        this.$content.removeClass(this.disabledClass);
        this.$content.one('transitionend', () => {
          this.inProgress = false;
          $messageLoader.removeClass(this.activeClass);
          $messageErrorMark.removeClass(this.activeClass);
        });
      });
    });
  }
}



// WEBPACK FOOTER //
// ./components/Form/Form.js